module.exports = __webpack_public_path__ + "static/result_gwacheon-d2497de5d4fdfc6b3a86ee3694e7f480.png";